var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/bulletin_healthcare_icon.png"),"alt":"healthcareIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }